import { getDefaultHomeRole, useHomeRole } from "components/materials/home/use-home-role";
import { useAppSelector } from "store/index";
import { selectLastHomeRole } from "store/selectors";
import { HomeRole, homeUrlForRole } from "utils/urls";

/** Prefer lastHomeRole while roles hydrate; after load, only if still available. */
export const resolveHomeUrl = (
  lastHomeRole: HomeRole | null,
  availableRoles: HomeRole[],
  isHomeRoleLoading: boolean,
) => {
  if (lastHomeRole && (isHomeRoleLoading || availableRoles.includes(lastHomeRole))) {
    return homeUrlForRole(lastHomeRole);
  }

  return homeUrlForRole(getDefaultHomeRole(availableRoles));
};

export const useHomeUrl = () => {
  const lastHomeRole = useAppSelector(selectLastHomeRole);
  const { availableRoles, isHomeRoleLoading } = useHomeRole();

  return resolveHomeUrl(lastHomeRole, availableRoles, isHomeRoleLoading);
};
